import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
const pains = ["Studi ore e ore, ma arrivi all'esame e ti si confonde tutto.", 'Durante il tirocinio in clinica resti muto quando ti chiedono un dosaggio.', "L'università ti insegna la teoria, ma non come agire in una vera emergenza.", "Non sai come parlare al proprietario dell'animale senza sembrare insicuro.", 'Senti che ogni anno studi di più e capisci meno come applicarlo.'];
export function PainPoints() {
  return <section className="w-full bg-red-50/40 py-14 px-4 border-y border-red-100" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-red-700 mb-3" data-id="element-185">
          Ti suona familiare?
        </h2>
        <p className="text-center text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-186">
          La realtà dello studente (e del neolaureato) in veterinaria che
          nessuno ti racconta:
        </p>

        <ul className="space-y-3" data-id="element-187">
          {pains.map((pain, i) => <li key={i} className="flex items-start gap-3 bg-white border border-red-200 rounded-lg px-4 py-3 shadow-sm" data-id="element-188">
              <AlertCircleIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-189" />
              <span className="text-red-700 font-medium leading-snug" data-id="element-190">
                {pain}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}